function formatCapitals(str) {
    if (typeof str !== 'string') {
        return ''
    }

    return str
        .toLowerCase()
        .split('_')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
}

module.exports = { formatCapitals }
